var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useIcon } from '@shapeable/icons';
import { Icon } from './icon';
var cls = classNames('lozenge-embed');
export var LozengeEmbedDefaultProps = {
  colors: {
    text: 'strong',
    background: 'rgba(0, 0, 0, 0.25)',
    border: 'strong'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-flex;\n    align-items: center;\n    gap: ", ";\n    padding: ", " ", " ", " ", ";\n    border-radius: ", ";\n    border-style: solid;\n    border-width: 1px;\n    ", ";\n  "], ["\n    display: inline-flex;\n    align-items: center;\n    gap: ", ";\n    padding: ", " ", " ", " ", ";\n    border-radius: ", ";\n    border-style: solid;\n    border-width: 1px;\n    ", ";\n  "])), theme.UNIT(1), theme.UNIT(2), theme.UNIT(6), theme.UNIT(2), theme.UNIT(2), theme.UNIT(10), theme.APPLY_COLORS)
});
var IconStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-right: ", ";\n    flex-shrink: 0;\n  "], ["\n    margin-right: ", ";\n    flex-shrink: 0;\n  "])), theme.UNIT(3))
});
var LabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    text-transform: uppercase;\n    font-size: 1.5em;\n    font-weight: 500;\n    color: inherit;\n  "], ["\n    text-transform: uppercase;\n    font-size: 1.5em;\n    font-weight: 500;\n    color: inherit;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(Icon)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Label: styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles)
};
export var LozengeEmbed = function (props) {
  var className = props.className,
    iconName = props.iconName,
    label = props.label,
    colors = props.colors,
    backgroundColor = props.backgroundColor;
  var Icon = useIcon(iconName);
  return React.createElement(My.Container, {
    colors: colors,
    className: cls.name(className)
  }, Icon && React.createElement(My.Icon, {
    size: 48,
    color: colors === null || colors === void 0 ? void 0 : colors.text
  }, " ", React.createElement(Icon, null), " "), React.createElement(My.Label, null, label));
};
LozengeEmbed.cls = cls;
LozengeEmbed.defaultProps = LozengeEmbedDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;